import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Login() {
  // Fixes AUDIT_REPORT C3: the form used to be pre-filled with the default
  // admin/admin123 credentials, and those credentials were printed on
  // screen below the form. Both are removed.
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/auth/login', { username, password });
      login(res.data.user, res.data.token);
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return React.createElement('div', {
    style: { minHeight: '100vh', background: 'linear-gradient(to bottom right, #2563eb, #7c3aed)', display: 'flex', alignItems: 'center', justifyContent: 'center' }
  },
    React.createElement('div', {
      style: { background: 'white', borderRadius: 16, padding: 32, width: '100%', maxWidth: 400, boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }
    },
      React.createElement('div', { style: { textAlign: 'center', marginBottom: 24 } },
        React.createElement('h1', { style: { fontSize: 28, fontWeight: 'bold', color: '#1e293b' } }, '\u{1F4B0} Nirav Finance'),
        React.createElement('p', { style: { color: '#64748b', marginTop: 8 } }, 'Sign in to your account')
      ),
      error && React.createElement('div', { style: { background: '#fee2e2', color: '#dc2626', padding: 12, borderRadius: 8, marginBottom: 16 } }, error),
      React.createElement('form', { onSubmit: handleSubmit },
        React.createElement('div', { style: { marginBottom: 16 } },
          React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, color: '#374151', marginBottom: 4 } }, 'Username'),
          React.createElement('input', {
            type: 'text', value: username, onChange: e => setUsername(e.target.value), autoFocus: true, autoComplete: 'username',
            style: { width: '100%', padding: 12, border: '1px solid #d1d5db', borderRadius: 8, fontSize: 16, boxSizing: 'border-box' }, required: true
          })
        ),
        React.createElement('div', { style: { marginBottom: 16 } },
          React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, color: '#374151', marginBottom: 4 } }, 'Password'),
          React.createElement('input', {
            type: 'password', value: password, onChange: e => setPassword(e.target.value), autoComplete: 'current-password',
            style: { width: '100%', padding: 12, border: '1px solid #d1d5db', borderRadius: 8, fontSize: 16, boxSizing: 'border-box' }, required: true
          })
        ),
        React.createElement('button', {
          type: 'submit', disabled: loading,
          style: { width: '100%', padding: 12, background: '#2563eb', color: 'white', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer' }
        }, loading ? 'Signing in...' : 'Sign In')
      )
    )
  );
}
